// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-box {
  width: 478px;
  max-width: 100%; /* keeps it responsive on smaller screens */
}

.new-box .modal-header {
  height: 35px;
  line-height: 35px; /* keeps text vertically centered */
}

.semibold{
  font-family: Open Sans-SemiBold variable, Helvetica;
  font-weight: 600;
  line-height: 16px;
}

.new-box-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.new-box-form fieldset {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 12px;
}

.new-box-form legend {
  padding: 0 4px;
  font-size: 14px;
  color: #171A1C;
}

.new-box-form input {
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
}

.new-box-form input::placeholder {
  color: #888;
  font-style: italic;
}

.disabled-label {
  color: #aaa;
  cursor: not-allowed;
}
.disabled-label .radio-img {
  opacity: 0.5;
}

.form-actions {
  border-top: 1px solid#e6e6e6;
  display: flex;
  gap: 12px;
  height: 61px;
  width: 478px;
  align-items: end;
}

.white-button{
  all: unset;
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-color);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  height: 48px;
  width: 233px;
  padding: 6px 24px;
  position: relative;
  font-family: Open Sans-SemiBold variable, Helvetica;
  font-size: 16px;
  color: var(--brand-color)
}

.blue-button{
  all: unset;
  align-items: center;
  background-color: #F0F0F0;
  border-radius: var(--border-radius-radius-sm-duplicate);
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  height: 48px;
  width: 233px;
  padding: 6px 24px;
  position: relative;
  font-family: Open Sans-SemiBold variable, Helvetica;
  font-size: 16px;
  color: #9FA6AD;
  cursor: not-allowed;
}

.blue-button {
  align-items: center;
  border: none;
  border-radius: var(--border-radius-radius-sm-duplicate);
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  height: 48px;
  width: 233px;
  padding: 6px 24px;
  font-family: Open Sans-SemiBold variable, Helvetica;
  font-size: 16px;
}

.blue-button:disabled {
  background-color: #F0F0F0;
  color: #9FA6AD;
  cursor: not-allowed;
}

.blue-button:enabled {
  background-color: var(--brand-color);
  color: #FFFFFF;
  cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/components/NewPackoutBox/NewPackoutBox.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe,EAAE,2CAA2C;AAC9D;;AAEA;EACE,YAAY;EACZ,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mDAAmD;EACnD,eAAe;EACf;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mDAAmD;EACnD,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,eAAe;AACjB","sourcesContent":[".new-box {\n  width: 478px;\n  max-width: 100%; /* keeps it responsive on smaller screens */\n}\n\n.new-box .modal-header {\n  height: 35px;\n  line-height: 35px; /* keeps text vertically centered */\n}\n\n.semibold{\n  font-family: Open Sans-SemiBold variable, Helvetica;\n  font-weight: 600;\n  line-height: 16px;\n}\n\n.new-box-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.new-box-form fieldset {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.new-box-form legend {\n  padding: 0 4px;\n  font-size: 14px;\n  color: #171A1C;\n}\n\n.new-box-form input {\n  width: 100%;\n  border: none;\n  outline: none;\n  font-size: 14px;\n}\n\n.new-box-form input::placeholder {\n  color: #888;\n  font-style: italic;\n}\n\n.disabled-label {\n  color: #aaa;\n  cursor: not-allowed;\n}\n.disabled-label .radio-img {\n  opacity: 0.5;\n}\n\n.form-actions {\n  border-top: 1px solid#e6e6e6;\n  display: flex;\n  gap: 12px;\n  height: 61px;\n  width: 478px;\n  align-items: end;\n}\n\n.white-button{\n  all: unset;\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-color);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  height: 48px;\n  width: 233px;\n  padding: 6px 24px;\n  position: relative;\n  font-family: Open Sans-SemiBold variable, Helvetica;\n  font-size: 16px;\n  color: var(--brand-color)\n}\n\n.blue-button{\n  all: unset;\n  align-items: center;\n  background-color: #F0F0F0;\n  border-radius: var(--border-radius-radius-sm-duplicate);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  height: 48px;\n  width: 233px;\n  padding: 6px 24px;\n  position: relative;\n  font-family: Open Sans-SemiBold variable, Helvetica;\n  font-size: 16px;\n  color: #9FA6AD;\n  cursor: not-allowed;\n}\n\n.blue-button {\n  align-items: center;\n  border: none;\n  border-radius: var(--border-radius-radius-sm-duplicate);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  height: 48px;\n  width: 233px;\n  padding: 6px 24px;\n  font-family: Open Sans-SemiBold variable, Helvetica;\n  font-size: 16px;\n}\n\n.blue-button:disabled {\n  background-color: #F0F0F0;\n  color: #9FA6AD;\n  cursor: not-allowed;\n}\n\n.blue-button:enabled {\n  background-color: var(--brand-color);\n  color: #FFFFFF;\n  cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
